import i18n from 'services/base/i18n';

export default {
  /* The user can explicitly assign a device type to a device (for example, when the Pangolin guesses wrong). This is the placeholder for that input box which tells the user that by default he will let the Pangolin try to detect what it is. */
  placeholder: () => i18n.pgettext('Components|Select Device Type', 'Automatically detect'),
  /* If the user clicks on the box, it brings up a dropdown box. This is the placeholder for the search box on that dropdown. */
  search: () => i18n.pgettext('Components|Select Device Type', 'Search'),
};
